<template>
  <div>
    <div class="kt-portlet">
      <div class="kt-portlet__body">
        <div v-if="!active_customers.length" class="row">
          <div class="col-12">
            <div class="alert alert-secondary" role="alert">
              <div class="alert-icon">
                <i class="la la-warning" />
              </div>
              <div class="alert-text">
                The primary Customer account has been disabled. If you wish to re-enable any disabled Customers, please contact <a href="mailto:support@sharp-stream.com">SharpStream Support</a>.
                If you are not seeing a customer in the list below that you expected, it is likely that your Organisation Admin has not given you access to the Customer.
              </div>
            </div>
          </div>
        </div>
        <div v-if="customers.length" class="row">
          <div class="col-12">
            <div class="alert alert-secondary" role="alert">
              <div class="alert-icon">
                <i class="la la-question-circle" />
              </div>
              <div class="alert-text">
                Your Organisation has multiple Customer accounts. Please select one to proceed.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div v-for="customer in customers" :key="customer.uuid" class="col-6">
            <div class="card text-center">
              <div class="card-header">
                <h5>{{ customer.name }}</h5>
              </div>
              <div class="card-body">
                <p class="card-text" />
                <a v-if="customer.status === 1"
                   href="javascript:"
                   class="btn btn-ss-standout w-100"
                   @click="selectCustomer(customer.uuid)">
                  Proceed
                </a>
                <p v-else class="text-center">
                  This Customer has been disabled. Please contact <a href="mailto:support@sharp-stream.com">SharpStream Support</a> if you wish to re-enable it.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customers: window.customers,
    };
  },
  computed: {
    active_customers() {
      return _.filter(this.customers, {
        'status': 1,
      });
    },
  },
  methods: {
    selectCustomer(customer_uuid) {
      axios.post("/api/v1/select-customer", {
        customer_uuid: customer_uuid,
      }).then((response) => {
        if (response.data.data) {
          toastr.success("Redirecting");
          window.location.href = "/";
        }
      }).catch((error) => {
        window.handleAxiosError(error);
      });
    },
  },
};
</script>
